import apiClient from './api';

export interface LeaveRequestData {
    id: string;
    startDate: string;
    endDate: string;
    type: string;
    reason?: string;
    status: string;
    adminNotes?: string;
    user?: { id?: string; name: string; email: string };
    userId: string;
    createdAt?: string;
    reviewedBy?: { id: string; name: string; email?: string } | null;
    reviewedAt?: string;
    reviewedByRole?: string;
    affectedShiftCount?: number;
}

export const createLeaveRequest = async (data: { startDate: string; endDate: string; type: string; reason?: string }) => {
    const response = await apiClient.post('/leave', data);
    return response.data;
};

export const getLeaveRequests = async (scope?: 'all') => {
    const params = scope ? `?scope=${scope}` : '';
    const response = await apiClient.get(`/leave${params}`);
    return response.data;
};

export const updateLeaveStatus = async (id: string, status: string, adminNotes?: string) => {
    const response = await apiClient.patch(`/leave/${id}/status`, { status, adminNotes });
    return response.data;
};

export const deleteLeaveRequest = async (id: string) => {
    const response = await apiClient.delete(`/leave/${id}`);
    return response.data;
};

export const getLeaveConflicts = async (startDate: string, endDate: string) => {
    const response = await apiClient.get(`/leave/conflicts?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
};
